import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/views/home/index'
import About from '@/views/about/index'
import Appraise from '@/views/appraise/index'
import Consult from '@/views/consult/index'
import News from '@/views/news/index'
import NewsDetails from '@/views/news/modules/detailsModal'
import Project from '@/views/project/index'
import Publicity from '@/views/consult/publicity'

Vue.use(Router)

export default new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'HelloWorld',
        //     component: HelloWorld
        // },
        {
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/appraise',
            name: 'Appraise',
            component: Appraise
        },
        {
            path: '/consult',
            name: 'Consult',
            component: Consult
        },
        {
            path: '/news',
            name: 'News',
            component: News
        },
        {
            path: '/news-details',
            name: 'NewsDetails',
            component: NewsDetails
        },
        {
            path: '/project',
            name: 'Project',
            component: Project
        },
        {
            path: '/publicity',
            name: 'Publicity',
            component: Publicity
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js